export default "__VITE_ASSET__rp0fmLpL__"